const repurchaseAdapters = {
  transformForAPI: (data) => {
    return data;
  },
  transformForBO: (data) => {
    return {
      ...data,
      brand: data.brand.uuid,
      brandModels: data.brandModels.map((b) => b.uuid),
      fuelTypes: data.fuelTypes.map((f) => f.id),
    };
  },
};

export default repurchaseAdapters;
